import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, skipPhotoGate = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#009E60] border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/discover" replace />;
  }

  // Photo-required gate: block all dating routes until user has an uploaded photo
  if (!skipPhotoGate && !isAdmin) {
    const hasPhoto = user.photo_status === 'uploaded' && Array.isArray(user.photos) && user.photos.length > 0;
    const isPhotoStopper = user.photo_status === 'required' || user.photo_status === 'removed_by_admin';
    // Allowed even without photo: own profile edit, notifications, pricing, payment success
    const alwaysAllowed = [
      '/profile',           // own profile
      '/profile/setup',
      '/notifications',
      '/pricing',
      '/payment',
    ];
    const path = location.pathname;
    const allowed = alwaysAllowed.some((p) => path === p || path.startsWith(p + '/'));
    if (!hasPhoto && isPhotoStopper && !allowed) {
      try { localStorage.setItem('gv_after_photo_return', location.pathname + location.search); } catch { /* ignore */ }
      return <Navigate to="/photo-required" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
